import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as TillStatusActions from './till-status.actions';
import { map, withLatestFrom } from 'rxjs/operators';
import { JournalService } from '@boma/supplier-portal/shared/services';
import { Store } from '@ngrx/store';
import { fetch } from '@nx/angular';

@Injectable()
export class TillStatusEffects {
  getTillStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TillStatusActions.loadTillStatus),
      fetch({
        run: (action, state: any) => {
          const selectedEntityId = action.payload.entityId;
          const selectedLocationId = action.payload.locationId;
          return this.journalService
            .getStatus(selectedEntityId, selectedLocationId)
            .pipe(
              map((response) =>
                TillStatusActions.loadTillStatusSuccess({ payload: response })
              )
            );
        },
        onError: (action, error) => {
          console.error('Error', error);
          return TillStatusActions.loadTillStatusFailure({ error });
        },
      })
    )
  );
  setOpenCashPosition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TillStatusActions.setOpenCashPosition),
      withLatestFrom(this.store),
      fetch({
        run: (action, state: any) => {
          const selectedEntityId = action.payload.entityId;
          const selectedLocationId = action.payload.locationId;
          return this.journalService
            .setOpenCashPosition(
              selectedEntityId,
              selectedLocationId,
              action.payload
            )
            .pipe(
              map((response) =>
                TillStatusActions.loadTillStatusSuccess({ payload: response })
              )
            );
        },
        onError: (action, error) => {
          console.error('Error', error);
          return TillStatusActions.loadTillStatusFailure({ error });
        },
      })
    )
  );
  closeCashPosition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TillStatusActions.closeCashPosition),
      withLatestFrom(this.store),
      fetch({
        run: (action, state: any) => {
          const selectedEntityId = action.payload.entityId;
          const selectedLocationId = action.payload.locationId;
          return this.journalService
            .closeCashPosition(
              selectedEntityId,
              selectedLocationId,
              action.payload
            )
            .pipe(
              map((response) =>
                TillStatusActions.loadTillStatusSuccess({ payload: response })
              )
            );
        },
        onError: (action, error) => {
          console.error('Error', error);
          return TillStatusActions.loadTillStatusFailure({ error });
        },
      })
    )
  );

  constructor(
    private actions$: Actions,
    private journalService: JournalService,
    private store: Store
  ) {}
}
